import i18next from 'i18n';
import { generatePath } from 'react-router-dom';
import { SessionDTO } from 'types/dto/login';

const SUPPORTED_LANGS = ['en', 'zh'];

const buildPath = (path: string, params: object = {}) => {
  let lang = i18next.language || 'en';

  if (!SUPPORTED_LANGS.includes(lang.toLowerCase())) {
    lang = 'en';
  }

  return generatePath(`/:lang${path}`, {
    lang,
    ...params,
  });
};

// Build path methods (sorted alphabetically)
export const buildBenefitsPath = () =>
  buildPath('/benefits');

export const buildCouponsAndVouchersPath = () =>
  buildPath('/wallet/coupons-and-vouchers');

export const buildEmailInputPath = (session: SessionDTO) =>{
  return buildPath('/email-input');
};

export const buildEmailInputEmailVerifiedPath = () =>
  buildPath('/email-input-email-verified');

export const buildEmailLinkExpiredPath = () =>
  buildPath('/email-link-expired');

export const buildEmailLinkExpiredWithSignUpPath = () =>
  buildPath('/email-link-expired-with-sign-up');

export const buildEmailSentPath = () =>
  buildPath('/email-sent');

export const buildExpiredAndUsedPath = () =>
  buildPath('/wallet/expired-and-used');

export const buildLandingPath = () =>
  buildPath('/landing');

export const buildLoginPath = () =>
  buildPath('/signin');

export const buildNewOrderPath = () =>
  buildPath('/order/create-order');

export const buildNewOrderResultPath = () =>
  buildPath('/order/order-result');

export const buildOrderHistoryDetailPath = (id: string) =>
  buildPath('/order/order-history/:id', { id });

export const buildOrderHistoryListPath = () =>
  buildPath('/order/order-history');

export const buildPasswordCreatePath = () => {
  return buildPath('/password-create');
};

export const buildPasswordCreateSuccessPath = () =>
  buildPath('/password-create-success');

export const buildPasswordResetPath = (token?: string) => {
  const basePath = buildPath('/password-reset');
  return token ? `${basePath}?reset_token=${token}` : basePath;
};


export const buildPasswordResetEmailSentPath = () =>
  buildPath('/password-reset-email-sent');

export const buildPasswordResetSuccessPath = () =>
  buildPath('/password-reset-success');

export const buildPasswordChangeSuccessPath = () =>
  buildPath('/password-change-success');

export const buildProfilePath = () =>
  buildPath('/profile');

export const buildRedeemPath = () =>
  buildPath('/redeem');

export const buildRegistrationPath = () =>
  buildPath('/registration');

export const buildRegistrationSuccessPath = () =>
  buildPath('/registration-success');

export const buildSessionExpiredPath = () =>
  buildPath('/session-expired');

export const buildTipsPath = () =>
  buildPath('/tips');

export const buildPasswordInputPath = () => {
  return buildPath('/password-input');
};

export const buildTermsPath = () => {
  return buildPath('/policy/terms-and-condition');
};

export const buildPolicyPath = () => {
  return buildPath('/policy/privacy-policy');
};